export const INITIAL_FETCH_REPORT = "INITIAL_FETCH_REPORT";
export const SET_REPORT_PAGE = "SET_REPORT_PAGE";
export const SET_REPORT_ROW = "SET_REPORT_ROW";
